module.exports = __webpack_public_path__ + "static/media/9.2e554c5d.JPG";